<template>
  <div>
    <v-container fluid>
      <v-card class="card">
        <v-toolbar color="primary" dark>
          <v-toolbar-title class="title">{{
            $t("managementModelAndVector")
          }}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-title class="title">{{ today }}</v-toolbar-title>
        </v-toolbar>
        <v-flex class="flex">
          <v-row style="margin-top: 2rem">
            <!-- <v-col cols="3" class="mt-3">
              <v-text-field
                :label="'Model Name'"
                v-model="searchModelName"
              ></v-text-field>
            </v-col>

            <v-col cols="3">
              <v-btn class="primary white--text mt-3" @click="Search">{{
                $t("search")
              }}</v-btn>
            </v-col> -->
            <v-col cols="12" justify="end" align="end">
              <v-btn
                class="primary white--text mt-3"
                style="margin-left: 1em"
                @click="Add()"
                >{{ $t("add") }}</v-btn
              >
            </v-col>
          </v-row>
          <v-data-table
            :items-per-page="itemsPerPage"
            :server-items-length="searchTotalTable"
            :options.sync="options"
            :items="dataTable"
            :headers="headers"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>{{ item.number }}</td>
                <td style="text-align: left;">{{ item.gptModelName ?? "-" }}</td>
                <td style="text-align: left;">{{ item.vectorDBName }}</td>
                <td>
                  <v-btn icon @click="Edit(item)">
                    <img :src="images.edit" />
                  </v-btn>
                </td>
                <td>
                  <v-btn icon @click="DeleteVectorDBNameMappinghGPTModel(item.gptModelName,item.vectorDBName)">
                    <img :src="images.delete" />
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <br />
        <br />
        <br />
      </v-card>
    </v-container>

    <!-- Add GPTModel -->
    <v-dialog v-model="Adddialog" persistent max-width="1000px">
      <v-card>
        <v-card-title class="card-header">
          <span class="headline">{{ $t("addModelAndVector") }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  :label="'Model Name'"
                  :items="DDGPTModel"
                  item-text="name"
                  item-value="id"
                  clearable
                  v-model="modelId"
                  :rules="[rules.required]"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  :label="'Vector DB name'"
                  :items="DDVector"
                  item-text="name"
                  item-value="name"
                  clearable
                  v-model="vectorDBName"
                  :rules="[rules.required]"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-btn
                  class="primary white--text mt-3"
                  style="margin-left: 1em"
                  @click="Save()"
                  >{{ $t("add") }}</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="Clear()">{{
            $t("close")
          }}</v-btn>
          <!-- <div v-show="true">
            <v-btn color="blue darken-1" text @click="Save()">{{
              $t("save")
            }}</v-btn>
          </div> -->
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="EditdialogUser" persistent max-width="1000px">
      <v-card>
        <v-card-title class="card-header">
          <span class="headline">{{ $t("addModelAndVector") }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  :label="'Model Name'"
                  :items="DDGPTModel"
                  item-text="name"
                  item-value="id"
                  clearable
                  v-model="modelId"
                  :rules="[rules.required]"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  :label="'Vector DB name'"
                  :items="DDVector"
                  item-text="name"
                  item-value="name"
                  clearable
                  v-model="vectorDBName"
                  :rules="[rules.required]"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-btn
                  class="primary white--text mt-3"
                  style="margin-left: 1em"
                  @click="Save()"
                  >{{ $t("add") }}</v-btn
                >
              </v-col>
            </v-row>
            <v-data-table
              :items-per-page="itemsPerPage2"
              :server-items-length="searchTotalTable2"
              :options.sync="options2"
              :items="dataTable2"
              :headers="headers2"
              :loading="loadingTable" 
              loading-text="Loading..."
            >
              <!-- <template v-slot:header="{ props: { headers } }">
                <thead>
                  <tr>
                    <th>{{ $t("no") }}</th>
                    <th>Vector DB name</th>
                    <th>{{ $t("delete") }}</th>
                  </tr>
                </thead>
              </template> -->
              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.number }}</td>
                  <td>{{ item.vectorDBName }}</td>
                  <td>
                    <v-btn icon @click="DeleteVectorDBNameMappinghGPTModel(true,item.vectorDBName)">
                      <img :src="images.delete" />
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="Clear()">{{
            $t("close")
          }}</v-btn>
          <!-- <div v-show="true">
            <v-btn color="blue darken-1" text @click="Save()">{{
              $t("save")
            }}</v-btn>
          </div> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay  :value="dialog">
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="#1976D2" dark>
        <v-card-text class="white--text">
          Loading Please Wait...
          <v-progress-linear indeterminate color="#FAA91B" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    </v-overlay>
  </div>
</template>
<script>
import call from "../api/call";
import checkPermissionTwo from "@/api/function.js";
import LogTrace from "@/api/function.js";
export default {
  name: "ModelAndVectorManagement",
  mixins: [checkPermissionTwo, LogTrace],
  data: () => ({
    checkbox1: false,
    EditdialogUser: false,
    Adddialog: false,
    dialog: false,
    loadingTable: false,
    tempID: 0,
    today: null,
    searchTotalTable: 0,
    totalTable: 0,
    itemsPerPage: 10,
    searchTotalTable2: 0,
    totalTable2: 0,
    itemsPerPage2: 10,
    loading: true,
    options: {},
    options2: {},
    rules: {
      required: (value) => !!value || "Required.",
    },
    DDProvider: [
      "Azure",
      "Azure Postgresql",
      "Azure Internet",
      "Azure Internet",
      "Azure News",
    ],
    DDGPTModel: [],
    DDVector: [],
    headers: [],
    headers2: [],
    modelId: null,
    vectorDBName: null,
    searchModelId: null,
    isSearch: false,
    isFirst: true,
    isSearch2: false,
    isFirst2: true,
    dataTable: [],
    dataTable2: [],
    images: {
      edit: require("@/assets/edit1.png"),
      delete: require("@/assets/delete1.png"),
    },
  }),
  watch: {
    options: {
      handler() {
        this.Get();
      },
      deep: true,
    },
    options2: {
      handler() {
        this.GetByName();
      },
      deep: true,
    },
  },
  methods: {
    Refresh() {
      this.EditdialogUser = false;
      // window.location.reload();
    },
    Search() {
      let self = this;
      self.dialog = true;
      self.isSearch = true;
      self.Get();
    },
    Get() {
      let self = this;
      self.dialog = true;
      self.loading = true;
      const { page, itemsPerPage } = this.options;
      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
      };
      call.GetVectorDBNameMappinghGPTModel(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          self.dialog = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    GetByName() {
      let self = this;
      self.loadingTable = true;
      const { page, itemsPerPage } = this.options2;
      let temp = {
        page: self.isSearch2 ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable2,
        id: self.searchModelId
      };
      call.GetVectorDBNameMappinghGPTModelById(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable2 = dataResponse.data.total;
            self.dataTable2 = dataResponse.data.data;
            self.totalTable2 = self.isFirst2
              ? dataResponse.data.total
              : self.totalTable2;
          } else {
            self.dataTable2 = [];
            self.searchTotalTable2 = 0;
            self.totalTable2 = 0;
          }
          self.loadingTable = false;
          self.isSearch2 = false;
          self.isFirst2 = false;
        },
        (errorResource) => {
          self.dialog = false;
          self.isSearch2 = false;
          console.error(errorResource);
        }
      );
    },
    GetDDGPTModel() {
      let self = this;
      self.dialog = true;
      call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDGPTModel = dataResponse.data;
          } else {
            self.DDGPTModel = [];
          }
          self.dialog = false;
          self.GetDDVectorDBName();
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    GetDDVectorDBName() {
      let self = this;
      self.dialog = true;
      call.GetDDVectorDBName(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDVector = dataResponse.data;
          } else {
            self.DDVector = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    Save() {
      let self = this;
      if(!self.modelId || !self.vectorDBName){
        alert("Please Fill All The Fields!");
        return;
      }
      self.dialog = true;
      let request = {
        modelId : self.modelId,
        vectorDBName : self.vectorDBName
      };
      try {
          call.UpdateVectorDBNameMappinghGPTModel(
            request,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                alert(dataResponse.message);
                self.Adddialog = false;
                self.Clear();
                self.Get();
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Adddialog = false;
              console.error(errorResource);
            }
          );
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    DeleteVectorDBNameMappinghGPTModel(modelName, name) {
      if(!modelName){
        alert("There are no connected models.");
        return;
      }
      try {
        let deleteconfirm = confirm("Are you sure to delete this data?");
        if (deleteconfirm == true) {
          let self = this;
          self.dialog = true;
          call.DeleteVectorDBNameMappinghGPTModel(
            name,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                alert(dataResponse.message);
                self.Clear();
                self.Get();
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Adddialog = false;
              console.error(errorResource);
            }
          );
        } else {
          self.dialog = false;
        }
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    Add() {
      let self = this;
      self.Adddialog = true;
    },
    Edit(item) {
      let self = this;
      self.vectorDBName = item.vectorDBName;
      self.modelId = item.gptModelID;
      if(item.gptModelID){
        self.EditdialogUser = true;
        self.searchModelId = item.gptModelID;
        if(!this.isFirst2){
          this.GetByName();
        }
      }
      else self.Add();
      
    },
    Clear() {
      let self = this;
      self.EditdialogUser = false;
      self.Adddialog = false;

      self.searchModelId = null;
      self.dataTable2 = [];
      self.searchTotalTable2 = 0;
      self.totalTable2 = 0;

      self.modelId = null;
      self.vectorDBName = null;
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
  },
  mounted() {
    this.GetDate();
    this.GetDDGPTModel();
    this.headers = [{
        text: this.$t("no"),align: 'center',sortable: false,},
      { text: 'Model name',align: 'center',sortable: false, },
      { text: 'Vector DB name',align: 'center',sortable: false, },
      { text: this.$t("edit"),align: 'center',sortable: false, },
      { text: this.$t("delete"),align: 'center',sortable: false, }
    ]
    this.headers2 = [{
        text: this.$t("no"),align: 'center',sortable: false,},
      { text: 'Vector DB name',align: 'center',sortable: false, },
      { text: this.$t("delete"),align: 'center',sortable: false, }
    ]
    
    // this.Get();
  },
};
</script>
<style scoped>
.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}
textarea {
  min-height: 800px !important;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
</style>
